<template>
  <div>
    {{ source._id }} | {{ source.type }} | {{ source.balance
    }}{{ source.status ? ` | ${getStatusText(source.status)}` : ""
    }}{{ source.transactionId ? ` | ${source.transactionId}` : ""
    }}{{
      source.createdAt
        ? ` | ${$dayjs(source.createdAt).format("DD.MM.YYYY HH:mm:ss")}`
        : ""
    }}
    => {{ source.cumulative }}
  </div>
</template>

<script>
export default {
  name: "HistoryItemComponent",
  props: {
    index: {
      // index of current item
      type: Number
    },
    source: {
      // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    getStatusText(status) {
      switch (+status) {
        case 0:
          return "В обработке";
        case 1:
          return "Подтверждено";
        case 2:
          return "Отклонено";
        default:
          return "";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Users/components/BalanceHistory/HistoryItem.vue